import React from "react"
import { convertOBlocksToText } from "../../../../../../../../../libs/converter/block-converter/to-text"
import { Block } from "../../../../../../../../../rpcs/dist/EpisodeRPC"
import { ContentActionDispatcher } from "../../../../../../../actiondispacher/content-action-dispacher"
import { IEditorContent } from "../../../../../../../types"

export interface IBaseEditorProps {
  content: IEditorContent
  actions: ContentActionDispatcher
}

// エディターの基底クラス
export default abstract class BaseEditor<P, S> extends React.Component<P, S> {
  protected abstract save(): void

  protected abstract cancel(): void

  protected abstract shouldShallowRemove(): boolean

  protected abstract shouldRemoveContent(): boolean

  protected abstract setFocus(): void

  protected isEmptyText(blocks: Block[]): boolean {
    return convertOBlocksToText(blocks) === ""
  }
}
